import React, { FC } from 'react';
import { BodyText, FlexCol, FlexRow, PrimaryButton } from '@minecraft.atoms';
import { useTranslation } from '@blocs.i18n';
import { PaywallLocation } from '../../enums/PaywallLocation';
import { UseBilling } from '../../useBilling';
import { UseThreeDSecureFlow } from '../../ThreeDSecureFlow';
import AuthorizeMessage from '../../PaymentMethodsManager/AuthorizeMessage';

export type WalletCTAProps = {
  allowCancel?: boolean;
  onCancel?: () => void;
  ctaLabel?: string;
  showAuthorizeMessage?: boolean;
  addPaymentError?: UseBilling['addPaymentError'];
  disabled?: boolean;
  hideSubmit?: boolean;
  // Set only for the nested "add card during checkout" use — bypasses Formik's onSubmit. Omitted → type="submit".
  onSubmitClick?: () => void | Promise<void>;
  paywallLocation?: PaywallLocation;
  threeDActionContext?: UseThreeDSecureFlow['threeDActionContext'];
};

export const WalletCTA: FC<WalletCTAProps> = ({
  allowCancel,
  onCancel,
  ctaLabel,
  showAuthorizeMessage,
  addPaymentError,
  disabled,
  hideSubmit,
  onSubmitClick,
  paywallLocation,
  threeDActionContext,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {showAuthorizeMessage && <AuthorizeMessage />}
      <FlexCol className="cn_w-full" justifyContent="flex-end" gap="2" alignItems="flex-end">
        {addPaymentError && !threeDActionContext?.token && <BodyText color="error">{addPaymentError}</BodyText>}
        <FlexRow gap="2" wrap="nowrap">
          {allowCancel && (
            <PrimaryButton
              type="button"
              isSmall
              onClick={onCancel}
              variant="secondary"
              label={t('common:button.cancel')}
              disabled={disabled}
              fixedWidth
            />
          )}
          {!hideSubmit &&
            (onSubmitClick ? (
              <PrimaryButton
                type="button"
                isSmall
                label={ctaLabel ?? t('common:paywall.addPaymentMethod.title')}
                onClick={onSubmitClick}
                data-unique-id={`add-payment-method-${paywallLocation}`}
                disabled={disabled}
                fixedWidth
              />
            ) : (
              <PrimaryButton
                type="submit"
                isSmall
                label={ctaLabel ?? t('common:paywall.addPaymentMethod.title')}
                data-unique-id={`add-payment-method-${paywallLocation}`}
                disabled={disabled}
                fixedWidth
              />
            ))}
        </FlexRow>
      </FlexCol>
    </>
  );
};
